module.exports = __webpack_public_path__ + "static/img/businessLogo1.755c4a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/businessLogo1.jpg
// module id = Saa+
// module chunks = 1